declare global {
    interface Window {
        gtag?: (...args: any[]) => void;
        dataLayer?: any[];
    }
}

/**
 * Track a Google Analytics event if gtag is available.
 */
export function trackEvent(
    eventName: string,
    params?: Record<string, any>
): void {
    console.log('eventName', eventName)
    console.log('eventParams', params)

    waitForGtag(() => {
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, params);
        } else {
            console.warn(`[GA] Not loaded yet`, eventName, params);
        }
    })
}

/**
 * Wait until gtag becomes available, then run callback.
 */
export function waitForGtag(callback: () => void, timeout = 10000): void {
    const start = Date.now();

    const check = () => {
        if (typeof window.gtag === 'function') {
            callback();
        } else if (Date.now() - start < timeout) {
            requestAnimationFrame(check);
        } else {
            console.warn('[GA] gtag not found within timeout.');
        }
    };

    check();
}
